import types from './types';

const INITIAL_STATE = {
  isFetching: false,
  isFetchingList: false,
  isFetchingFile: false,

  result: [],
};

const eligibilityRAFScoreReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.GET_RAF_SCORE_REQUEST:
      return {
        ...state,
        result: [],
        isFetching: true,
      };

    case types.GET_RAF_SCORE_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetching: false,
      };

    case types.GET_RAF_SCORE_FAILURE:
      return {
        ...state,
        result: [],
        isFetching: false,
      };

    case types.GET_RAF_SCORE_LIST_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingList: true,
      };

    case types.GET_RAF_SCORE_LIST_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingList: false,
      };

    case types.GET_RAF_SCORE_LIST_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingList: false,
      };

    case types.GET_RAF_SCORE_FILE_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingFile: true,
      };

    case types.GET_RAF_SCORE_FILE_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingFile: false,
      };

    case types.GET_RAF_SCORE_FILE_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingFile: false,
      };

    case types.GET_HISTORICAL_RAF_SCORE_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingHistoricalRafScore: true,
      };

    case types.GET_HISTORICAL_RAF_SCORE_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingHistoricalRafScore: false,
      };

    case types.GET_HISTORICAL_RAF_SCORE_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingHistoricalRafScore: false,
      };

    default:
      return state;
  }
};

export default eligibilityRAFScoreReducer;
